import RoutesComponent from "./Routes";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
const AppDir = "rtl";

// Set cache key and plugin based on the direction
const rtlCacheKey = AppDir === "rtl" ? "muirtl" : "muiltr";
const rtlCachePlugins = AppDir === "rtl" ? [prefixer, rtlPlugin] : [prefixer]; // No need for an LTR plugin

// Create the cache with the correct plugin for RTL/LTR
const rtlCache = createCache({
    key: rtlCacheKey,
    stylisPlugins: rtlCachePlugins,
});

// Create the theme dynamically based on the direction
const theme = createTheme({
    direction: AppDir, // Dynamically set direction
    typography: {
        fontFamily: "Arial", // You can set the font family here if needed
    },
    palette: {
        mode: "light", // Dynamically set mode "light" or "dark"
    },
});

const App = () => {
    return (
        <CacheProvider value={rtlCache}>
            <ThemeProvider theme={theme}>
                <RoutesComponent />
            </ThemeProvider>
        </CacheProvider>
    );
};

export default App;
